const checkDisplay = (viewports) => {
  const windowWidth = window.innerWidth
  let display

  for (const viewport in viewports) {
    let viewportWidth = viewports[viewport]
    if (Array.isArray(viewportWidth)) {
      ;[viewportWidth] = viewportWidth
    }
    if (windowWidth >= parseInt(viewportWidth)) {
      display = viewport
      break
    }
  }

  return display
}

export default checkDisplay
